import state from './businessState'
import mutations from './businessMutations'
import actions from './businessActions'
import getters from './businessGetters'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
